<template>
  <v-container fluid>
    <div>
      <v-tabs
        v-model="activeTab"
        color="transparent"
        :label="activeTab"
        show-arrows
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="(tabItem) in tabs"
          :key="tabItem"
        >
          <span class="tabItem">
            {{ tabItem }}
          </span>
        </v-tab>
          <v-tab-item key="active">
            <PaginationController
              v-model="activeBillingList"
              getDataActionName="getImportService"
              :showDataLimit="showDataLimit"
              :searchBoxLabel="$t('search')"
              :searchBoxHint="$t('importSearchBoxHint')"
              :select="activeSelectedImportStatus || null"
              :isRefreshSelect='false'
              haveSearchBox
              haveStartDate
            >
              <template v-slot:dataTable>
                <v-data-table
                  :headers="headers"
                  :items.sync="activeBillingList"
                  hide-actions
                  item-key="_key"
                  select-all="blue"
                  class="elevation-2 myDense"
                  :pagination.sync="activePagination"
                  :value="selectedItems"
                  :rows-per-page-items="rowPerPage"
                >
                  <template v-slot:headers="props">
                    <tr>
                      <th>
                        <v-checkbox
                          :input-value="props.all"
                          primary
                          hide-details
                          @click.stop="toggleAll"
                        ></v-checkbox>
                      </th>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :style="{width: header.width, textAlign: header.align}"
                        :class="['column sortable', activePagination.descending ? 'desc' : 'asc', header.value === activePagination.sortBy ? 'active' : '']"
                        @click="header.value === 'createTime' && changeSort(activePagination, header.value)"
                      >
                      <v-icon small v-if="header.value === 'createTime'">arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>

                  <template v-slot:items="props">
                    <td class="checkbox-align-center">
                      <v-layout>
                        <v-checkbox
                          @click.stop="changeSelectedItems(props)"
                          :value="props.selected"
                          primary
                          hide-details
                          :disabled='props.item.billingNumber !== props.item.masterBillingNumber'
                        ></v-checkbox>
                      </v-layout>
                    </td>
                    <td>
                      {{ props.item.billingNumber }}
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon color="blue" v-on="on" style="font-size:10px;line-height:25px" small v-if="isAdmin && props.item.billingNumber !== props.item.masterBillingNumber" @click="copyToClipboard(props.item.masterBillingNumber)">content_copy</v-icon>
                        </template>
                        <span>{{$t('copyMasterBillingNumber')}}</span>
                      </v-tooltip>
                    </td>
                    <td>{{ props.item.containerNumber }}</td>
                    <td>{{ toDateString(props.item.createTime) }}</td>
                    <td :style="{ whiteSpace: 'pre-wrap' }">{{ props.item.serviceTypes.length ? props.item.serviceTypes.reduce((pre,cur) => $t(pre) + '\n' + $t(cur)) : '' }}</td>
                    <td>{{ $t(props.item.lastStatus) }}</td>
                    <td v-if="isAdmin">{{ props.item.displayName }}</td>
                    <td v-if="isAdmin" :style="{ whiteSpace: 'pre' }">{{ props.item.internalNote }}</td>
                    <td text-xs-center>
                      <v-layout justify-space-between>
                        <v-flex>
                          <v-btn dark color="primary" flat @click.stop="showDetailPopup(props.item)">
                              {{ $t('open') }}
                          </v-btn>
                        </v-flex>
                        <v-menu offset-y v-if="isAdmin">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" flat dark color="primary">
                              {{ $t('more') }}<v-icon>expand_more</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-tile @click="showCreatePopupAndProcess(props.item, 'update')">
                              <v-list-tile-title>{{ $t('edit') }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="showCreatePopupAndProcess(props.item, 'split')" v-if="props.item.billingNumber === props.item.masterBillingNumber">
                              <v-list-tile-title>{{ $t('split') }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="updateItem(props.item, 'close')" v-if="props.item.billingNumber === props.item.masterBillingNumber">
                              <v-list-tile-title>{{ $t('close') }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="updateItem(props.item, 'delete')">
                              <v-list-tile-title>{{ $t('delete') }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-layout>
                    </td>
                  </template>
                </v-data-table>
              </template>
              <template v-slot:beforeSearchBox>
                <v-layout row justify-start align-baseline>
                  <v-flex v-if="isAdmin" style="width:205px">
                    <v-layout>
                      <v-flex sm6>
                        <v-btn
                          color="primary"
                          @click="showCreatePopupAndProcess({},'create')"
                        >
                          <v-icon dark>add</v-icon>
                          {{$t('newImportBilling')}}
                        </v-btn>
                      </v-flex>
                      <v-flex sm6>
                        <v-btn
                          v-if="isAdmin"
                          color="info"
                          :disabled='selectedItems.length === 0'
                          @click="processMultiImportOrder('multiClose')"
                        >
                          <v-icon>lock</v-icon>
                          {{$t('close')}}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex :style="isAdmin ? 'width:200px' : 'width:300px'">
                    <v-autocomplete
                      :label="$t('selectStatus')"
                      v-model="activeSelectedImportStatus"
                      :items='statusList'
                      item-value="status"
                      item-text="text"
                      clearable></v-autocomplete>
                  </v-flex>
                </v-layout>
              </template>
            </PaginationController>
            <SimpleTextPopup
              :title="$t('importRelatedService')"
              v-model="isShowCreatePopup"
              medium
            >
              <template v-slot:input>
                <v-container>
                  <v-form ref="popUpForm">
                    <v-container>
                      <v-layout column>
                        <v-flex>
                          <v-layout justify-space-between>
                            <v-flex sm5>
                              <v-text-field
                                v-model="tableDataIndeed.billingNumber"
                                :readonly="actionType !== 'create'"
                                :label="$t('billingNumber')"
                                :rules="[
                                  fieldIsRequired($t('billingNumber'))
                                ]"
                              ></v-text-field>
                            </v-flex>
                            <v-flex sm5>
                              <v-text-field
                                :readonly="actionType === 'split' || detailInShowItem.billingNumber !== detailInShowItem.masterBillingNumber || !!(detailInShowItem.associatedBillingList && detailInShowItem.associatedBillingList.length)"
                                v-model="tableDataIndeed.containerNumber"
                                :label="$t('containerNumber')"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex>
                          <v-layout justify-space-between align-end>
                            <v-flex sm5>
                              <v-autocomplete
                                :label="$t('client')"
                                v-model="tableDataIndeed.userKey"
                                :items='overseaCustomersList'
                                :readonly="(actionType === 'update' && detailInShowItem.lastStatus !== 'created')"
                                item-value="userKey"
                                item-text="displayName"
                                :clearable='detailInShowItem.lastStatus === "created"'
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex sm5>
                              <v-combobox
                                :items="serviceTypeList"
                                v-model="selectedServiceTypes"
                                item-text="displayName"
                                item-value="displayName"
                                :label="$t('serviceType')"
                                :return-object="false"
                                required
                                chips
                                multiple
                                clearable />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex>
                          <v-textarea
                            outline
                            name="input-7-4"
                            :label="$t('internalNote')"
                            v-model="tableDataIndeed.internalNote"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-container>
              </template>
               <template v-slot:popupAction>
                <v-layout row justify-space-between>
                  <v-flex class="text-xs-left">
                    <slot name="left_button">
                      <v-btn color="primary" flat @click.stop="cancelAndCloseDialog">{{$t('close')}}</v-btn>
                    </slot>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <slot name="right_button">
                      <LoaderButton
                        flat
                        isSmall
                        :promiseAwait="closeDialogAndProcessImport"
                        :buttonText="$t('save')"
                      ></LoaderButton>
                    </slot>
                  </v-flex>
                </v-layout>
              </template>
            </SimpleTextPopup>
            <SimpleTextPopup
             :large="true"
             :leftMethod='closeDetailDialog'
             :hideRgtBtn="true"
             v-model="isShowImportOrderDetail"
             :title="$t('importRelateInfo',{billingNumber: detailInShowItem.billingNumber, containerNumber: detailInShowItem.containerNumber})"
            >
             <template v-slot:input>
               <v-container fluid>
                 <v-layout row>
                   <v-flex xs3>
                     <v-layout justify-start column>
                        <v-toolbar color="primary" dark>
                          <v-toolbar-title>{{ $t('status') }}</v-toolbar-title>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-flex xs12 sm8  v-for="(card,index) in cards" :key="String(card.operationTime) + '_' + index">
                          <v-card>
                            <!-- <v-container
                              fluid
                              grid-list-md
                            > -->
                              <v-layout column wrap>
                                <v-flex mt-2 mb-2>
                                    <v-card style="max-width:300px;height:60px;margin:auto;color:white;" color="info">
                                      <v-container fluid style="padding:10px;color:white;font-weight:700">
                                        <v-layout align-center justify-center>
                                          <v-flex sm1 mr-4>
                                              <div style="border:1px;background:white;border-radius:50%;color:#2196f3;text-align:center">
                                                {{cards.length - index}}
                                              </div>
                                          </v-flex>
                                          <v-flex sm9>
                                            <v-layout column justify-start align-start>
                                            <v-flex>{{toTimestampString(card.operationTime)}}</v-flex>
                                            <v-flex>{{$t(card.status)}}</v-flex>
                                            <v-flex v-if="false">操作人: {{card.operator}}</v-flex>
                                          </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-container>
                                    </v-card>
                                </v-flex>
                              </v-layout>
                            <!-- </v-container> -->
                          </v-card>
                        </v-flex>
                    </v-layout>
                   </v-flex>
                   <v-flex xs9>
                    <v-layout justify-center>
                      <v-flex xs11>
                        <v-toolbar color="primary" dark>
                          <v-toolbar-title>{{$t('filesAndOperation')}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card>
                          <v-container
                            fluid
                            grid-list-md
                          >
                            <v-layout column wrap>
                              <v-flex v-if="isAdmin">
                                <v-layout v-if="activeTab === 0">
                                  <v-flex sm6 ml-4>
                                    <v-autocomplete
                                      :label="$t('status')"
                                      v-model="newStatus"
                                      :items='statusList'
                                      item-value="status"
                                      item-text="text"
                                      no-data-text='all'
                                      clearable></v-autocomplete>
                                  </v-flex>
                                  <v-flex ml-4 sm2>
                                    <LoaderButton
                                      :promiseAwait="updateOrderStatus"
                                      :promiseItem="{type: 'admin'}"
                                      :buttonText="$t('changeStatus')"
                                    ></LoaderButton>
                                  </v-flex>
                                  <v-flex sm2 v-if="(detailInShowItem.billingNumber === detailInShowItem.masterBillingNumber) && detailInShowItem.associatedBillingList && detailInShowItem.associatedBillingList.length">
                                    <v-checkbox
                                      v-model="isSyncAssociatedImports"
                                      :label="$t('syncAssociations')"
                                    ></v-checkbox>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex v-if="!isAdmin && detailInShowItem.lastStatus === 'customFileReadyToConfirm' && isMatchClient">
                                <v-card  v-if="!detailInShowItem.close">
                                  <v-container fluid>
                                    <v-layout justify-center align-center>
                                      <v-flex>{{ $t('areYouSureToConfirmClearance') }}</v-flex>
                                      <v-flex xs3>
                                        <LoaderButton
                                          :promiseAwait="updateOrderStatus"
                                          :promiseItem="{type: 'user'}"
                                          :buttonText="$t('confirmToCustomsClearance')"
                                        ></LoaderButton>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card>
                              </v-flex>
                              <v-flex v-if="!isAdmin && detailInShowItem.lastStatus === 'customFileConfirmed'">
                                <v-card>
                                  <v-container>
                                    <v-layout justify-center align-center>
                                      <v-flex xs8>{{$t('thanksForSupport')}}</v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card>
                              </v-flex>
                              <v-flex mt-4>
                                <v-layout column>
                                  <v-flex sm2  style="font-size:18px"><strong>{{$t('filesList')}}</strong></v-flex>
                                  <v-flex 
                                    v-for="({value,type}) in filesTitleOrderList"
                                    :key="type"
                                   >
                                    <v-layout column justify-start>
                                      <v-flex ml-4 @click="setUploadFileType(type)" sm6>
                                        <strong style="font-weight:700;display:inline-block;width:100px">{{value}}</strong>
                                        <UploadFileWidget
                                          v-model="newFiles"
                                          :clearFiles ='true'
                                          :disabled="(type === 'deliveryFiles' && filesListOfInshowItem[type] && filesListOfInshowItem[type].length >= 1) || (!isAdmin && type === 'billingFiles') || (filesListOfInshowItem[type] && filesListOfInshowItem[type].length >= 5) || isUploading || !isMatchClient || (activeTab === 1 && !isAdmin)"
                                          ref="fileUploader"
                                          :type="'import' + '/' + detailInShowItem.billingNumber"
                                          iconType = 'add'
                                          isCheckDuplicates
                                          @getUploadingFileData = 'getUploadingFileDataAndSaveFileInfo'
                                          :loading="isUploading && type === uploadingFileType"
                                          icon
                                        />
                                        <v-tooltip top v-if="type === 'deliveryFiles'">
                                          <template v-slot:activator="tooltip">
                                            <div v-on="tooltip.on" style="display:inline-block">
                                              <v-btn plain flat v-if="type === 'deliveryFiles'" color="primary" @click="downloadTemplate"><v-icon>download</v-icon>{{$t('template')}}</v-btn>
                                            </div>
                                          </template>
                                          {{ $t('template') }}
                                        </v-tooltip>
                                        <!-- <a :href="123" download>
                                          <v-btn plain flat v-if="type === 'deliveryFiles'" color="primary"><v-icon>download</v-icon></v-btn>
                                        </a> -->
                                      </v-flex>
                                      <v-flex ml-5 xs10>
                                        <v-list style="padding:0px">
                                          <v-list-tile
                                            v-for="subItem in mergedFilesList[type]"
                                            :key="subItem.downloadURL"
                                            style="height:25px;padding:0px"
                                           >
                                             <v-layout style="margin:0px;padding:0px;height:50px" align-start>
                                               <v-flex sm6 style="font-size:14px">
                                                 {{subItem.name}}
                                               </v-flex>
                                               <v-flex sm3 style="font-size:14px">
                                                 {{toTimestampString(subItem.uploadTime)}}
                                               </v-flex>
                                               <v-flex sm3 style="font-size:14px" v-if="isAdmin && detailInShowItem.billingNumber === detailInShowItem.masterBillingNumber" @click.prevent="changeFileIsSharedStatus(subItem, type)">
                                                 <v-checkbox
                                                  v-if="subItem.hasOwnProperty('isShared') && !subItem.isLoadingShareBtn"
                                                  style="font-size:14px;display:inline-block"
                                                  v-model="subItem.isShared"
                                                  :label="$t('public')"
                                                  :disabled='subItem.isLoadingShareBtn'
                                                 ></v-checkbox>
                                                 <v-btn flat small loading v-if="subItem.isLoadingShareBtn"></v-btn>
                                               </v-flex>
                                               <v-flex sm3>
                                                 <v-layout row>
                                                   <v-flex sm2>
                                                     <v-tooltip top>
                                                      <template v-slot:activator="tooltip">
                                                        <div v-on="tooltip.on">
                                                          <v-icon
                                                              v-if="(isAdmin || (type !== 'billingFiles' && subItem.uploader === user.uid && isMatchClient))"
                                                              @click="deleteFileFromStorage(subItem, type)"
                                                            >delete</v-icon>
                                                        </div>
                                                      </template>
                                                      {{ $t('delete') }}
                                                    </v-tooltip>
                                                   </v-flex>
                                                   <v-flex sm2>
                                                     <v-tooltip top>
                                                      <template v-slot:activator="tooltip">
                                                        <div v-on="tooltip.on">
                                                          <a :href="subItem.downloadURL" download target="_blank">
                                                            <v-icon v-if="isAdmin || (!isAdmin && isMatchClient)">cloud_download</v-icon>
                                                          </a>
                                                        </div>
                                                      </template>
                                                      {{ $t('download') }}
                                                    </v-tooltip>
                                                   </v-flex>
                                                 </v-layout>
                                               </v-flex>
                                             </v-layout>
                                          </v-list-tile>
                                        </v-list>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex v-if="detailInShowItem.deliveryInfo && detailInShowItem.deliveryInfo.length !== 0">
                                <v-layout column mt-4>
                                  <v-flex sm2>
                                    <v-layout>
                                      <v-flex style="font-size:18px" mb-2><strong>{{$t('deliveryStatus')}}</strong></v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex ml-4>
                                    <v-data-table
                                      :headers="deliveryHeaders"
                                      :rows-per-page-items="[10,20,30]"
                                      :items="detailInShowItem.deliveryInfo"
                                      class="elevation-1"
                                    >
                                      <template v-slot:items="props">
                                        <td>{{ props.item.channel }}</td>
                                        <td class="text-xs-left">{{ props.item.quantity }}</td>
                                        <td class="text-xs-left">{{ props.item.flag }}</td>
                                        <td class="text-xs-left">{{ props.item.weight }}</td>
                                        <td class="text-xs-left">{{ props.item.volume }}</td>
                                        <td class="text-xs-left">{{ props.item.note }}</td>
                                        <td class="justify-center layout px-0" v-if="isAdmin">
                                          <v-autocomplete
                                            v-model="props.item.deliveryStatus"
                                            :items='deliveryStatusList'
                                            item-value="status"
                                            item-text="text">
                                          </v-autocomplete>
                                        </td>
                                        <td v-else>
                                          {{ $t(props.item.deliveryStatus) }}
                                        </td>
                                      </template>
                                    </v-data-table>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex>
                                <v-layout v-if="isAdmin" mt-4>
                                  <v-flex sm2 ml-4>
                                    <v-text-field
                                      v-model="HSCode"
                                      label="HSCode"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex sm9 v-if="isAdmin">
                                    <v-layout justify-end>
                                      <v-flex sm2>
                                        <LoaderButton
                                          :promiseAwait="processDeliveryInfo"
                                          :promiseItem="{data: {...detailInShowItem}, type: 'delivery'}"
                                          :buttonText="$t('save')"
                                        ></LoaderButton>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </v-layout>
                   </v-flex>
                 </v-layout>
               </v-container>
             </template>
            </SimpleTextPopup>
          </v-tab-item>
          <v-tab-item key="history">
            <PaginationController
              v-model="closedBillingList"
              getDataActionName="getImportService"
              :showDataLimit="showDataLimit"
              :searchBoxLabel="$t('search')"
              :searchBoxHint="$t('importSearchBoxHint')"
              :select="closedSelectedImportStatus || null"
              :actionPredicates='historyActionPredicates'
              :isRefreshSelect='false'
              isStartWithoutData
              haveSearchBox
              haveStartDate
              mb-4
            >
              <template v-slot:dataTable>
                <v-data-table
                  :headers="headers"
                  :items.sync="closedBillingList"
                  hide-actions
                  item-key="_key"
                  select-all="blue"
                  class="elevation-2 myDense"
                  v-model="selectedItems"
                  :rows-per-page-items="rowPerPage"
                  :custom-sort='sortTableData'
                >
                  <template v-slot:headers="props">
                    <tr>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :style="{width: header.width, textAlign: header.align}"
                      >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <!-- <td class="checkbox-align-center">
                      <v-layout>
                        <v-checkbox
                          @click.stop="() => { props.item && (props.selected = !props.selected) }"
                          :value="props.selected"
                          primary
                          hide-details
                          :disabled='props.item.billingNumber !== props.item.masterBillingNumber'
                        ></v-checkbox>
                      </v-layout>
                    </td> -->
                    <!-- <td>{{ props.item.billingNumber }}</td> -->
                    <td>
                      {{ props.item.billingNumber }}
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon color="blue" v-on="on" style="font-size:16px" small v-if="isAdmin && props.item.billingNumber !== props.item.masterBillingNumber" @click="copyToClipboard(props.item.masterBillingNumber)">info</v-icon>
                        </template>
                        <span>{{$t('copyMasterBillingNumber')}}</span>
                      </v-tooltip>
                    </td>
                    <td>{{ props.item.containerNumber }}</td>
                    <td>{{ toDateString(props.item.lastModifiedTime) }}</td>
                    <td :style="{ whiteSpace: 'pre-wrap' }">{{ props.item.serviceTypes.length ? props.item.serviceTypes.reduce((pre,cur) => $t(pre) + '\n' + $t(cur)) : ''}}</td>
                    <td>{{ $t(props.item.lastStatus) }}</td>
                    <td v-if="isAdmin">{{ props.item.displayName }}</td>
                    <td v-if="isAdmin" :style="{ whiteSpace: 'pre' }">{{ props.item.internalNote }}</td>
                    <td text-xs-center>
                      <v-layout justify-space-between>
                        <v-flex>
                          <v-btn dark color="primary" flat @click.stop="showDetailPopup(props.item)">
                              {{ $t('open') }}
                          </v-btn>
                        </v-flex>
                        <v-menu offset-y v-if="isAdmin">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" flat dark color="primary">
                              {{ $t('more') }}
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-tile @click="updateItem(props.item, 'reopen')" v-if="props.item.billingNumber === props.item.masterBillingNumber">
                              <v-list-tile-title>{{ $t('reopen') }}</v-list-tile-title>
                            </v-list-tile> 
                          </v-list>
                        </v-menu>
                      </v-layout>
                    </td>
                  </template>
                </v-data-table>
              </template>
              <template v-slot:beforeSearchBox>
                <v-layout row wrap justify-start align-baseline>
                  <v-flex sm6>
                    <v-autocomplete
                      :label="$t('selectStatus')"
                      v-model="closedSelectedImportStatus"
                      :items='statusList'
                      item-value="status"
                      item-text="text"
                      clearable></v-autocomplete>
                  </v-flex>
                </v-layout>
              </template>
            </PaginationController>
          </v-tab-item>
      </v-tabs>
    </div>
  </v-container>
</template>
<script>
import { timeTools, getFieldListColumnPosition, checkRules, copyToClipboard } from '@/utils/tools'
import xlsx from 'xlsx'
import PaginationController from '@/components/PaginationController'
import SimpleTextPopup from '@/components/SimpleTextPopup.vue'
import UploadFileWidget from '@/components/UploadFileWidget.vue'
import LoaderButton from '@/components/LoaderButton.vue'
import {queryWithPredicates} from '@/utils/dbAccessor'
export default {
  name: 'ImportService',
  data () {
    return {
      activeTab: 0,
      tabs: [
        this.$t('activeTab'),
        this.$t('history')
      ],
      supportSearch: '',
      rowPerPage: [25, 50, {text: this.$t('all'), value: -1}],
      activeBillingList: [],
      closedBillingList: [],
      showDataLimit: 30,
      selectedContainer: [],
      activeSelectedImportStatus: '',
      closedSelectedImportStatus: '',
      statusList: [
        {status: 'created', text: this.$t('importServiceCreated')},
        {status: 'isfMatched', text: this.$t('isfMatched')},
        {status: 'vesselDeparted', text: this.$t('vesselDeparted')},
        {status: 'customFileReadyToConfirm', text: this.$t('customFileReadyToConfirm')},
        {status: 'customFileConfirmed', text: this.$t('customFileConfirmed')},
        {status: 'inspectionRequired', text: this.$t('inspectionRequired')},
        {status: 'customReleased', text: this.$t('customReleased')},
        {status: 'containerArrival', text: this.$t('containerArrival')},
        {status: 'deliveryFileMissing', text: this.$t('deliveryFileMissing')},
        {status: 'waitingDOFile', text: this.$t('waitingDOFile')},
        {status: 'containerPickup', text: this.$t('containerPickup')},
        {status: 'unloading', text: this.$t('unloading')},
        {status: 'dispatchCompleted', text: this.$t('dispatchCompleted')}
      ],
      deliveryStatusList: [
        {status: 'pending', text: this.$t('pending')},
        {status: 'completed', text: this.$t('completed')}
      ],
      newFiles: [],
      filesTitleOrderList: [
        { type: 'isfFiles', value: this.$t('isfFiles') },
        { type: 'manifestFiles', value: this.$t('manifestFiles') },
        { type: 'clearanceFiles', value: this.$t('clearanceFiles') },
        { type: 'DOFiles', value: this.$t('DOFiles') },
        { type: 'deliveryFiles', value: this.$t('deliveryFiles') },
        { type: 'podFiles', value: this.$t('podFiles') },
        { type: 'billingFiles', value: this.$t('billingFiles') },
        { type: 'otherFiles', value: this.$t('otherFiles') }
      ],
      serviceTypes: {
        customsClearance: {
          displayName: this.$t('customsClearance'),
          key: 'customsClearance'
        }, 
        containerUnloading: {
          displayName: this.$t('containerUnloading'),
          key: 'containerUnloading'
        }
      },
      isShowCreatePopup: false,
      isShowImportOrderDetail: false,
      tableDataIndeed: {
        billingNumber: '',
        containerNumber: '',
        userKey: '',
        serviceTypes: ['customsClearance', 'containerUnloading'],
        internalNote: ''
      },
      actionType: '',
      detailInShowItem: {},
      filesListOfInshowItem: {},
      cards: [],
      newStatus: '',
      uploadingFileType: '',
      selectedItems: [],
      historyActionPredicates: [
        {
          field: 'close',
          compare: '==',
          value: true
        }
      ],
      isUploading: false,
      HSCode: null,
      isMatchClient: true,
      isSyncAssociatedImports: true,
      subscribedList: [],
      masterFiles: {},
      activePagination: {
        sortBy: 'createTime'
      }
    }
  },
  mixins: [timeTools, checkRules],
  components: {PaginationController, SimpleTextPopup, UploadFileWidget, LoaderButton},
  methods: {
    copyToClipboard,
    toggleAll () {
      if (this.selectedItems.length) { 
        (this.selectedItems = []) 
      } else {
        this.selectedItems = this.activeBillingList.slice()
      }
    },
    changeSort (pagination, column) {
      if (pagination.sortBy === column) {
        pagination.descending = !pagination.descending
      } else {
        pagination.sortBy = column
        pagination.descending = false
      }
    },
    changeSelectedItems (props) {
      const { selected, item } = props
      const { associatedBillingList = [] } = item
      if (selected) {
        this.selectedItems = this.selectedItems.filter(singleItem => singleItem.billingNumber !== item.billingNumber && !associatedBillingList.includes(singleItem.billingNumber))
      } 
      if (!selected) {
        this.selectedItems.push(props.item)
        associatedBillingList.length && this.selectedItems.push(...this.activeBillingList.filter(activeItem => associatedBillingList.includes(activeItem.billingNumber)))
      }
    },
    getOverseaCustomers () {
      this.$store.dispatch('getOverseaCustomers')
    },
    async processMultiImportOrder (type) {
      if (confirm(this.$t('areYouSureToChangeOrder', { type: this.$t('close') })) && type === 'multiClose') {
        const billingsNeedToClose = []
        this.selectedItems.forEach(item => billingsNeedToClose.push(item.billingNumber))
        await this.$store.dispatch('updateImportCloseStatus', {billingNumber: billingsNeedToClose, close: true})
        // await this.processImportOrder({billingsNeedToClose}, type)
        this.activeBillingList = this.activeBillingList.filter(item => !billingsNeedToClose.includes(item.billingNumber))
        this.closedBillingList = [...this.selectedItems, ...this.closedBillingList]
      }
    },
    async processDeliveryInfo (item) {
      let {data, type} = item
      if (this.HSCode) data = {...data, HSCode: +this.HSCode}
      return this.processImportOrder(data, type)
    },
    cancelAndCloseDialog () {
      this.isShowCreatePopup = false
      this.resetData()
    },
    closeDetailDialog () {
      this.subscribedList.length && this.subscribedList.forEach(subscriber => subscriber())
      // this.subscriber && this.subscriber()
      this.subscribedList = []
      this.activeBillingList = this.activeBillingList.map(item => {
        if (item.billingNumber.toLowerCase() === this.detailInShowItem.billingNumber.toLowerCase()) {
          return {...item, ...this.detailInShowItem}
        }
        return item
      })
      this.isShowImportOrderDetail = false
      this.isMatchClient = true
      this.detailInShowItem = {}
      this.masterFiles = {}
      this.isSyncAssociatedImports = true
    },
    async changeFileIsSharedStatus (item, type) {
      item.isLoadingShareBtn = true
      await this.processImportOrder({fileType: type, billingNumber: this.detailInShowItem.billingNumber, ...item}, 'updateFileStatus').then(() => {
        item.isLoadingShareBtn = false
      })
    },
    async closeDialogAndProcessImport () {
      if (!this.isImportServiceAvailable) {
        alert('Please select the oversea feature at first')
        return
      }
      const indeedData = {...this.tableDataIndeed}
      if (this.actionType === 'create') {
        indeedData.masterBillingNumber = indeedData.billingNumber
      }
      if (this.actionType === 'split') {
        indeedData.masterBillingNumber = this.detailInShowItem.billingNumber
      }
      if (this.actionType === 'update') {
        indeedData.masterBillingNumber = this.detailInShowItem.masterBillingNumber
      }
      if (this.$refs.popUpForm.validate()) {
        return this.processImportOrder({...indeedData, displayName: this.overseaCustomersMap.get(this.tableDataIndeed.userKey) || ''}, this.actionType)
          .then(() => {
            this.isShowCreatePopup = false
            this.resetData()
          })
      }
    },
    resetData () {
      Object.assign(this.tableDataIndeed, {
        billingNumber: '',
        containerNumber: '',
        userKey: '',
        serviceTypes: ['customsClearance', 'containerUnloading'],
        internalNote: ''
      })
      this.actionType = ''
      this.isMatchClient = true
      this.detailInShowItem = {}
      this.$refs.popUpForm.resetValidation()
      this.masterFiles = {}
    },
    async processImportOrder (data, actionType) {
      try {
        const {displayName, uid} = this.user
        const payload = {...data, type: actionType}
        if (actionType === 'create' || actionType === 'split') {
          const regex = /\s*/g
          payload.billingNumber = payload.billingNumber.replace(regex, '')
          payload.containerNumber = payload.containerNumber.replace(regex, '')
          payload.masterBillingNumber = payload.masterBillingNumber.replace(regex, '')
          payload.creator = (displayName || 'admin') + '_' + uid
          const predicates = [
            {
              field: 'keywords',
              compare: 'array-contains',
              value: payload.billingNumber.toLowerCase()
            }
          ]
          const orderDoc = await queryWithPredicates(predicates, ['importService'])
          if (!orderDoc.empty) throw Error(this.$t('billingNumberAlreadyExist'))
        } else {
          payload.operator = (displayName || 'admin') + '_' + uid
        }
        await this.$store.dispatch('processImportOrder', payload)
        // 处理前端变化
        if (actionType === 'update') {
          this.activeBillingList = this.activeBillingList.map(item => {
            if (item.billingNumber === data.billingNumber) {
              // if (data.files) return this.detailInShowItem 
              const lastModifiedTime = new Date()
              return {...item, ...data, lastStatus: this.newStatus || item.lastStatus, lastModifiedTime}
            }
            return item
          })
        } else if (actionType === 'create' || actionType === 'split') {
          const createTime = new Date()
          const newImportOrder = {
            ...payload,
            createTime,
            lastStatus: 'created',
            operationHistory: [{operator: payload.creator || payload.operator, operationTime: createTime, status: 'created'}],
            files: {
              isfFiles: [],
              packageFiles: [],
              clearCuostomsFiles: [],
              DOFiles: [],
              deliveryFiles: [],
              billingFiles: [],
              podFiles: [],
              others: []
            }
          }
          if (actionType === 'create') newImportOrder.associatedBillingList = []
          if (actionType === 'split') {
            this.activeBillingList = this.activeBillingList.map(item => {
              if (item.billingNumber === payload.masterBillingNumber) {
                item.associatedBillingList && item.associatedBillingList.push(payload.billingNumber)
              }
              return item
            })
          }
          this.activeBillingList.push(newImportOrder)
          this.resetData()
        }
        // else if (actionType === 'delivery') {
        //   const {deliveryInfo, billingNumber} = data
        //   this.detailInShowItem.deliveryInfo = deliveryInfo
        //   this.activeBillingList = this.activeBillingList.map(item => {
        //     if (item.billingNumber === billingNumber) return this.detailInShowItem
        //     return item
        //   })
        // }
      } catch (error) {
        this.isUploading = false
        this.$store.dispatch('showToast', {info: this.$t(error.message), level: 'error'})
        throw error
      }
    },
    async showDetailPopup (item) {
      const {billingNumber, masterBillingNumber} = item
      this.setDataSource(item)
      billingNumber === masterBillingNumber && await this.buildSingleImportChannel(item.billingNumber)
      billingNumber !== masterBillingNumber && await this.buildSingleImportChannel(item.billingNumber, item.masterBillingNumber)
      // !item.close && await this.buildSingleImportChannel(item.billingNumber)
      this.isShowImportOrderDetail = true
    },
    async showCreatePopupAndProcess (item, type) {
      const {billingNumber, containerNumber, userKey, serviceTypes, internalNote, associatedBillingList, masterBillingNumber} = item
      if (type === 'update') {
        this.tableDataIndeed = {billingNumber, containerNumber, userKey, serviceTypes, internalNote}
      }
      if (type === 'split') {
        let newBillingNumber
        if (associatedBillingList && associatedBillingList.length) {
          const finalAssociatedBilling = associatedBillingList && associatedBillingList.length && associatedBillingList[associatedBillingList.length - 1]
          const splitedArr = finalAssociatedBilling && finalAssociatedBilling.split('-')
          newBillingNumber = masterBillingNumber + '-' + (+splitedArr[splitedArr.length - 1] + 1)
        } else {
          newBillingNumber = masterBillingNumber + '-' + 1
        }
        this.tableDataIndeed = {billingNumber: newBillingNumber, containerNumber, serviceTypes}
      }
      this.actionType = type
      this.detailInShowItem = item
      this.isShowCreatePopup = true
    },
    async updateItem (item, type) {
      if (confirm(this.$t('areYouSureToChangeOrder', {type: this.$t(type)}))) {
        // await this.processImportOrder(item, type)
        const {billingNumber, masterBillingNumber, associatedBillingList} = item
        if (['reopen', 'close'].includes(type)) {
          await this.updateItemCloseStatus(item)
          if (type === 'close' && billingNumber === masterBillingNumber && associatedBillingList) {
            // this.activeBillingList = this.activeBillingList.filter(item => {
            //   // 此处只额外处理子单在前端的显示
            //   if (associatedBillingList.includes(item.billingNumber)) {
            //     this.closedBillingList.push(item)
            //     return false
            //   }
            //   return true
            // })
            const newActiveBillingList = []
            this.activeBillingList.forEach(activeImport => {
              if (!associatedBillingList.includes(activeImport.billingNumber)) {
                newActiveBillingList.push(activeImport)
              } else {
                this.closedBillingList.push(activeImport)
              }
            })
            this.activeBillingList = newActiveBillingList
            // this.closedBillingList.push(...this.activeBillingList.filter(activeImport => associatedBillingList.includes(activeImport.billingNumber)))
            // this.activeBillingList = this.activeBillingList.filter(activeImport => !associatedBillingList.includes(activeImport.billingNumber))
          }
          if (type === 'reopen' && billingNumber === masterBillingNumber && associatedBillingList) {
            // this.closedBillingList = this.closedBillingList.filter(closedItem => {
            //   if (associatedBillingList && associatedBillingList.includes(closedItem.billingNumber)) {
            //     this.activeBillingList.push(closedItem)
            //     return false
            //   }
            //   return true
            // })
            const newClosedBillingList = []
            this.closedBillingList.forEach(closedImport => {
              if (!associatedBillingList.includes(closedImport.billingNumber)) {
                newClosedBillingList.push(closedImport)
              } else {
                this.activeBillingList.push(closedImport)
              }
            })
            this.closedBillingList = newClosedBillingList
          }
        }
        if (type === 'delete') {
          await this.deleteOrders(item)
          associatedBillingList && (this.activeBillingList = this.activeBillingList.filter(item => !associatedBillingList.includes(item.billingNumber)))
        }
        const lastModifiedTime = new Date()
        if (type === 'reopen') {
          this.closedBillingList = this.closedBillingList.filter(billingItem => {
            if (billingItem.billingNumber === item.billingNumber) {
              this.activeBillingList.push({...billingItem, lastModifiedTime, close: !item.close})
            }
            return billingItem.billingNumber !== item.billingNumber
          })
        }
        if (type === 'close' || type === 'delete') {
          // this.activeBillingList = this.activeBillingList.filter(billingItem => {
          //   return billingItem.billingNumber !== item.billingNumber
          // })
          this.activeBillingList = this.activeBillingList.reduce((prev, cur) => {
            if (cur.billingNumber === item.billingNumber) return [...prev]
            if (cur.billingNumber === item.masterBillingNumber) {
              cur.associatedBillingList = cur.associatedBillingList.filter(billing => billing !== item.billingNumber)
            }
            return [...prev, cur]
          }, [])
          if (type === 'close') {
            this.closedBillingList.push({...item, lastModifiedTime, close: !item.close})
          }
        }
      }
    },
    async updateOrderStatus (item) {
      const type = item.type
      if (type === 'user') {
        this.newStatus = 'customFileConfirmed'
      }
      const {operationHistory, associatedBillingList} = this.detailInShowItem

      if (operationHistory && operationHistory[operationHistory.length - 1].status === this.newStatus) {
        this.$store.dispatch('showToast', {info: this.$t('cannotUpdateSameStatus')})
        return
      }
      const operationTime = new Date()
      const newCard = {status: this.newStatus, operator: (this.user.displayName || 'admin') + '_' + this.user.uid}
      const dataObj = {newCard, billingNumber: this.detailInShowItem.billingNumber, masterBillingNumber: this.detailInShowItem.masterBillingNumber}
      if (this.isSyncAssociatedImports && associatedBillingList && associatedBillingList.length) dataObj.associatedBillingList = associatedBillingList
      await this.processImportOrder(dataObj, 'update')

      // 子单前端 table 状态修改
      if (this.isSyncAssociatedImports && associatedBillingList && associatedBillingList.length) {
        const associatedImports = this.activeBillingList.map(importItem => {
          if (this.detailInShowItem.billingNumber === importItem.masterBillingNumber) {
            return importItem.billingNumber
          }
        })
        this.activeBillingList = this.activeBillingList.map(activeItem => {
          if (associatedImports.includes(activeItem.billingNumber)) {
            activeItem.operationHistory.push({...newCard, operationTime})
            activeItem.lastStatus = this.newStatus
          }
          return activeItem
        })
      }
    },
    async deleteFileFromStorage (subItem, key) {
      if (confirm(this.$t('uploadFileRemove'))) {
        await this.processImportOrder({ deleteFileObj: { [key]: {...subItem} }, billingNumber: this.detailInShowItem.billingNumber }, 'update')
        // 暂时不实际将文件删除，防止出现误删，确保误删后可以找回
        // await this.$store.dispatch('removeFile', subItem.fullPath)
        // this.detailInShowItem.files[key] = this.detailInShowItem.files[key].filter(file => file.fullPath !== subItem.fullPath)
        // if (key === 'deliveryFiles') this.detailInShowItem.deliveryInfo = []
        // this.activeBillingList = this.activeBillingList.map(activeBillingItem => {
        //   if (activeBillingItem.billingNumber === this.detailInShowItem.billingNumber) {
        //     return this.detailInShowItem
        //   }
        //   return activeBillingItem
        // })
      }
    },
    setUploadFileType (key) {
      this.uploadingFileType = key
    },
    async getUploadingFileDataAndSaveFileInfo (value) {
      const { file, metadata } = value
      if (!this.detailInShowItem.files[this.uploadingFileType]) {
        this.detailInShowItem.files[this.uploadingFileType] = []
      }
      if (!this.isAdmin && this.uploadingFileType === 'billingFiles') {
        this.isUploading = false
        return
      } 
      // const uploadTime = new Date()
      const newFileObj = this.isAdmin ? {files: {[this.uploadingFileType]: [{...metadata, uploader: this.user.uid, isShared: true}]}, billingNumber: this.detailInShowItem.billingNumber} : {files: {[this.uploadingFileType]: [{...metadata, uploader: this.user.uid}]}, billingNumber: this.detailInShowItem.billingNumber}
      // this.isAdmin && (newFileObj.isShared = true)
      await this.processImportOrder(newFileObj, 'update')
      // this.detailInShowItem.files[this.uploadingFileType].push({...metadata, uploader: this.user.uid, uploadTime})
      // this.activeBillingList = this.activeBillingList.map(item => {
      //   if (item.billingNumber === this.detailInShowItem.billingNumber) {
      //     return this.detailInShowItem
      //   }
      //   return item
      // })
      this.isUploading = false
      this.uploadingFileType === 'deliveryFiles' && await this.AnalyzeFormData(file)
    },
    async AnalyzeFormData (file) {
      let reader = new FileReader()
      reader.readAsBinaryString(file)
      reader.onload = async e => {
        let fileData = e.target.result
        const workbook = xlsx.read(fileData, {type: 'binary'})
        const sheetName = workbook.SheetNames[0]
        const workingSheetName = workbook.Sheets[sheetName]
        const targetColumnsList = ['channel', 'quantity', 'flag', 'weight', 'note', 'volume']
        let rawData = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName])
        const columnAlphabetMap = getFieldListColumnPosition(xlsx, workbook, sheetName, targetColumnsList, 1)
        const deliveryInfo = []
        for (let i = 1; i < rawData.length - 1; i++) {
          const deliveryObj = {}
          for (let index = 0; index < targetColumnsList.length; index++) {
            if (!workingSheetName[columnAlphabetMap.get('channel') + '' + (i + 2)]) continue
            const columnAlphabet = targetColumnsList[index]
            const position = workingSheetName[columnAlphabetMap.get(columnAlphabet) + '' + (i + 2)]
            const value = (position && position.v) || ''
            deliveryObj[columnAlphabet] = value
          }
          deliveryInfo.push({...deliveryObj, deliveryStatus: 'pending'})
        }
        await this.processImportOrder({deliveryInfo, billingNumber: this.detailInShowItem.billingNumber}, 'delivery')
      }
    },
    downloadTemplate () {
      this.$store.dispatch('downloadFile', {
        fullPath: 'templates/delivery-template.xlsx',
        name: 'delivery-template.xlsx'
      })
    },
    sortTableData (items) {
      return items.sort((prev, cur) => cur.lastModifiedTime - prev.lastModifiedTime)
    },
    async buildSingleImportChannel (billingNumber, masterBillingNumber) {
      if (masterBillingNumber) {
        const masterSubscriber = await this.$store.dispatch('subscribeSingleImport', {
          billingNumber: masterBillingNumber,
          cbFunc: this.getMasterImportSharedInfoRT
        })
        this.subscribedList.push(masterSubscriber)
      }
      const subscriber = await this.$store.dispatch('subscribeSingleImport', {
        billingNumber,
        cbFunc: this.getSingleImportInfoRT
      })
      this.subscribedList.push(subscriber)
    },
    getMasterImportSharedInfoRT (rtDocData) {
      this.masterFiles = rtDocData.files
    },
    getSingleImportInfoRT (rtDocData) {
      if (rtDocData.close && this.closedBillingList.find(item => item.billingNumber === rtDocData.billingNumber)) return
      if (rtDocData.close) {
        if (confirm(this.$t('orderHasBeenClosed'))) {
          this.closeDetailDialog()
          this.closedBillingList.every(item => item.billingNumber !== rtDocData.billingNumber) && this.closedBillingList.push(rtDocData)
          this.activeBillingList = this.activeBillingList.filter(billingItem => {
            return billingItem.billingNumber !== rtDocData.billingNumber
          })
        }
      }
      if (this.$store.getters.activeOrganization !== rtDocData.userKey && !this.isAdmin) {
        this.isMatchClient = false
        if (confirm(this.$t('orderHasBeenDeleted'))) {
          this.closeDetailDialog()
          this.activeBillingList = this.activeBillingList.filter(billingItem => {
            return billingItem.billingNumber !== rtDocData.billingNumber
          })
        }
      }
      this.setDataSource(rtDocData)
    },
    setDataSource (dataSource) {
      this.detailInShowItem = dataSource
      this.newStatus = dataSource.lastStatus
      this.filesListOfInshowItem = dataSource.files
      this.HSCode = dataSource.HSCode || 0
    },
    async updateItemCloseStatus (item) {
      const { billingNumber, close, masterBillingNumber, associatedBillingList = [] } = item
      billingNumber === masterBillingNumber && await this.$store.dispatch('updateImportCloseStatus', {billingNumber: [billingNumber, ...associatedBillingList], close: !close})
      billingNumber !== masterBillingNumber && await this.$store.dispatch('updateImportCloseStatus', {billingNumber, close: !close})
    },
    async deleteOrders (item) {
      await this.$store.dispatch('deleteImportOrders', item)
    }
  },
  created () {
    this.$store.dispatch('loadSystemInfo')
    this.getOverseaCustomers()
  },
  beforeDestroy () {
    this.subscribedList.length && this.subscribedList.forEach(subscriber => subscriber())
  },
  computed: {
    headers () {
      if (this.isAdmin) {
        return [
          { text: this.$t('billingNumber'), align: 'left', sortable: false, value: 'billingNumber', width: '10%' },
          { text: this.$t('containerNumber'), align: 'left', sortable: false, value: 'containerNumber', width: '10%' },
          { text: this.activeTab ? this.$t('lastModifiedTime') : this.$t('createTime'), value: this.activeTab ? 'lastModifiedTime' : 'createTime', align: 'left', sortable: !this.activeTab && 'desc', width: '6%' },
          { text: this.$t('serviceType'), value: 'serviceTypes', align: 'left', sortable: false, width: '14%' },
          { text: this.$t('status'), value: 'status', align: 'left', sortable: false, width: '10%' },
          { text: this.$t('client'), value: 'client', align: 'left', sortable: false, width: '10%' },
          { text: this.$t('note'), value: 'internalNote', align: 'left', sortable: false, width: '25%' },
          { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
        ]
      } else {
        return [
          { text: this.$t('billingNumber'), align: 'left', sortable: false, value: 'billingNumber', width: '20%' },
          { text: this.$t('containerNumber'), align: 'left', sortable: false, value: 'containerNumber', width: '20%' },
          { text: this.activeTab ? this.$t('lastModifiedTime') : this.$t('createTime'), value: this.activeTab ? 'lastModifiedTime' : 'createTime', align: 'left', sortable: false, width: '20%' },
          { text: this.$t('serviceType'), value: 'serviceTypes', align: 'left', sortable: false, width: '20%' },
          { text: this.$t('status'), value: 'status', align: 'left', sortable: false, width: '15%' },
          { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '5%' }
        ]
      }
    },
    deliveryHeaders () {
      return [
        { text: this.$t('carrier'), align: 'left', sortable: false, value: 'channel', width: '8%' },
        { text: this.$t('qty'), align: 'left', sortable: false, value: 'quantity', width: '8%' },
        { text: this.$t('flag'), value: 'flag', align: 'left', sortable: false, width: '28%' },
        { text: this.$t('weight'), value: 'weight', align: 'left', sortable: false, width: '8%' },
        { text: this.$t('volume'), value: 'volume', align: 'left', sortable: false, width: '8%' },
        { text: this.$t('note'), value: 'deliveryNote', align: 'left', sortable: false, width: '30%' },
        { text: this.$t('status'), value: '', align: 'center', sortable: false, width: '10%' }
      ]
    },
    isAdmin () {
      return !!(this.$store.getters.user || {}).isAdmin
    },
    user () {
      return this.$store.getters.user
    },
    selectedServiceTypes: {
      get () {
        const arr = []
        this.tableDataIndeed.serviceTypes.forEach(serviceKey => {
          arr.push(this.serviceTypes[serviceKey])
        })
        return arr
      },
      set (value) {
        const arr = []
        this.serviceTypeList.forEach(({displayName, key}) => {
          value.includes(displayName) && arr.push(key)
        })
        this.tableDataIndeed.serviceTypes = arr
      }
    },
    serviceTypeList () {
      return Object.values(this.serviceTypes)
    },
    overseaCustomersList () {
      return this.$store.getters.overseaCustomersList
    },
    overseaCustomersMap () {
      const overseaCustomersMap = new Map()
      this.overseaCustomersList.forEach(customer => overseaCustomersMap.set(customer.userKey, customer.displayName))
      return overseaCustomersMap
    },
    mergedFilesList () {
      const filesListObj = {}
      if (!Object.keys(this.filesListOfInshowItem).length) return {}
      for (let key in this.filesListOfInshowItem) {
        if (this.masterFiles[key]) { // 子单文件数据
          filesListObj[key] = this.isAdmin ? [...this.filesListOfInshowItem[key]] : [...this.filesListOfInshowItem[key], ...this.masterFiles[key].filter(file => file.isShared)]
        } else { // 主单文件数据
          filesListObj[key] = this.filesListOfInshowItem[key].map(item => { 
            this.$set(item, 'isLoadingShareBtn', false)
            return item 
          })
        }
      }
      return filesListObj
    },
    fullBetaFeatures () {
      return this.$store.getters.fullBetaFeatures || []
    },
    isImportServiceAvailable () {
      const betaFeature = this.fullBetaFeatures.find(feature => feature.key === 'oversea')
      return betaFeature && betaFeature.isEnabled
    }
  },
  watch: {
    'detailInShowItem.operationHistory': function (newValue, oldValue) {
      if (!newValue) return
      this.cards = [...newValue].reverse()
    },
    newFiles: function (newValue, oldValue) {
      if (newValue.length === oldValue.length) return
      this.isUploading = true
    }
  }
}
</script>
<style scoped>
.container.grid-list-md .layout .flex {
  padding: 0px;
}
.v-list__tile.theme--light { 
  height: 20px !important;
}
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>>



// WEBPACK FOOTER //
// src/components/ImportService.vue